import { useEffect } from 'react';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';

import { MoniebookLoader } from '@moniebook-web/components/molecules/moniebook-loader';
import { AlertFill } from '@moniebook-web/icons-v2/system/alert-fill';
import { CheckboxCircleFill } from '@moniebook-web/icons-v2/system/checkbox-circle-fill';
import { Information2Fill } from '@moniebook-web/icons-v2/system/information-2-fill';
import { ClientProvider } from '@moniebook-web/utils';
import {
    AlertProvider,
    CustomerMetricsProvider,
} from '@register-ui/components';
import { rehydrateConfigStorage, telemetry } from '@register-ui/utils';

import { config } from '@/config';
import appRouter from '@/routes/index';

export function App() {
    useEffect(() => {
        telemetry?.metrics.setupWebVitals();
        telemetry?.tracing.setup();
    }, []);

    useEffect(() => {
        rehydrateConfigStorage();
    }, []);

    return (
        <ClientProvider>
            <CustomerMetricsProvider
                cxMetricsOptions={{
                    appEnv: config.CUSTOMER_ANALYTICS_ENVIRONMENT,
                    applicationID: config.APPLICATION_ID,
                    baseAPIEndpoint: config.CUSTOMER_ANALYTICS_SERVICE,
                    platform: 'web',
                    sdkConfigurations: {
                        mixpanel: config.MIXPANEL,
                    },
                }}>
                <RouterProvider
                    router={createBrowserRouter(appRouter)}
                    fallbackElement={<MoniebookLoader fullHeight />}
                />
            </CustomerMetricsProvider>

            <AlertProvider />

            <Toaster
                position='top-center'
                icons={{
                    success: <CheckboxCircleFill />,
                    info: <Information2Fill />,
                    error: <AlertFill />,
                    warning: <AlertFill />,
                }}
                toastOptions={{
                    className: 'sonner-toast',
                    classNames: {
                        error: 'sonner_error',
                        success: 'sonner_success',
                        warning: 'sonner_warning',
                        info: 'sonner_info',
                        title: 'sonner_title',
                        content: 'sonner_content',
                        actionButton: 'sonner_action',
                    },
                }}
            />
        </ClientProvider>
    );
}

// biome-ignore lint/style/noDefaultExport: This has been rectified in the react 19 version
export default App;
